import { render, staticRenderFns } from "./BadgeSaudagar.vue?vue&type=template&id=4f463522&scoped=true&"
var script = {}
import style0 from "./BadgeSaudagar.vue?vue&type=style&index=0&id=4f463522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f463522",
  null
  
)

export default component.exports